export default "__VITE_ASSET__8e82aa2f__"